/** Brand system: design tokens per Master Architecture Document. */

export const colors = {
  primary: '#EC5B13',      // Primary Orange
  charcoal: '#221610',     // Deep Charcoal
  slate: '#94A3B8',        // Lab Slate
  background: '#F5F5F5',
  cardWhite: '#FFFFFF',
};

/** eCTD Module badge colors (Tailwind class pairs: bg + text) */
export const MODULE_COLORS: Record<string, { bg: string; text: string; label: string }> = {
  M1: { bg: 'bg-slate-100', text: 'text-slate-700', label: 'Administrative' },
  M2: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Summaries' },
  M3: { bg: 'bg-violet-100', text: 'text-violet-700', label: 'Quality (CMC)' },
  M4: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Nonclinical' },
  M5: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Clinical' },
};

/** Domain badge colors */
export const DOMAIN_COLORS: Record<string, { bg: string; text: string }> = {
  CMC: { bg: 'bg-violet-100', text: 'text-violet-700' },
  Clinical: { bg: 'bg-emerald-100', text: 'text-emerald-700' },
  Nonclinical: { bg: 'bg-amber-100', text: 'text-amber-700' },
  Administrative: { bg: 'bg-slate-100', text: 'text-slate-700' },
};

/** Relevance score thresholds */
export const RELEVANCE_THRESHOLDS = {
  HIGH: 0.8,
  MEDIUM: 0.5,
} as const;

export const MIN_CONFIDENCE_THRESHOLD = 0.95;
export const MODERATE_CONFIDENCE_THRESHOLD = 0.70;

export const API_BASE = import.meta.env.VITE_API_BASE ?? 'http://localhost:8000';

/** Storage provider mode — 'local' (filesystem) or 'sharepoint' (SharePoint Online). */
export const STORAGE_PROVIDER = (import.meta.env.VITE_STORAGE_PROVIDER ?? 'local') as 'local' | 'sharepoint';

/** True when the app is configured for SharePoint Online storage. */
export function isSPOMode(): boolean {
  return STORAGE_PROVIDER === 'sharepoint';
}

export function getRelevanceColor(score: number): string {
  if (score >= RELEVANCE_THRESHOLDS.HIGH) return 'bg-red-500';
  if (score >= RELEVANCE_THRESHOLDS.MEDIUM) return 'bg-amber-500';
  return 'bg-green-500';
}

export function getRelevanceLabel(score: number): string {
  if (score >= RELEVANCE_THRESHOLDS.HIGH) return 'High';
  if (score >= RELEVANCE_THRESHOLDS.MEDIUM) return 'Medium';
  return 'Low';
}
